import router from '@/router'
import { analytics, auth } from './firebase'

if (process.env.NODE_ENV !== 'production') {
  analytics.setAnalyticsCollectionEnabled(false)
}

router.beforeEach((to, from, next) => {
  analytics.setCurrentScreen(to.name)
  analytics.logEvent('screen_view', { screen_view: to.name })
  next()
})

auth.onAuthStateChanged(user => {
  if (user) {
    analytics.setUserId(user.uid)
  }
})
